// Render fragment for of — the entity's GraphQL display contract.
// Scaffolded once from the @medplum/definitions reverse projection; hand-curate
// freely to match what the view renders (this file is owned, not generated).
import { graphql } from '@eluve/graphql-fhir';

/**
 * Everything a Observation view (or the generic fallback) could render.
 * Compose into queries: graphql(`query { ... ...ObservationRender }`, [ObservationRenderFragment]).
 * References are terminal ({ reference type display }) — expand nested
 * `resource` selections in the query when resolved targets are needed.
 */
export const ObservationRenderFragment = graphql(`
  fragment ObservationRender on Observation @_unmask {
    resourceType
    id
    meta {
      versionId
      lastUpdated
      profile
      tag {
        system
        code
      }
      security {
        system
        code
        display
      }
    }
    modifierExtension {
      url
    }
    identifier {
      use
      system
      value
    }
    basedOn {
      reference
      type
      display
    }
    partOf {
      reference
      type
      display
    }
    status
    category {
      text
      coding {
        system
        code
        display
      }
    }
    code {
      text
      coding {
        system
        code
        display
      }
    }
    subject {
      reference
      type
      display
    }
    focus {
      reference
      type
      display
    }
    encounter {
      reference
      type
      display
    }
    effectiveDateTime
    effectivePeriod {
      start
      end
    }
    effectiveTiming {
      event
      repeat {
        boundsPeriod {
          start
          end
        }
        count
        countMax
        frequency
        frequencyMax
        period
        periodUnit
        dayOfWeek
        timeOfDay
        when
        offset
      }
      code {
        text
        coding {
          system
          code
          display
        }
      }
    }
    effectiveInstant
    issued
    performer {
      reference
      type
      display
    }
    valueQuantity {
      value
      comparator
      unit
      system
      code
    }
    valueCodeableConcept {
      text
      coding {
        system
        code
        display
      }
    }
    valueString
    valueBoolean
    valueInteger
    valueRange {
      low {
        value
        comparator
        unit
        system
        code
      }
      high {
        value
        comparator
        unit
        system
        code
      }
    }
    valueRatio {
      numerator {
        value
        comparator
        unit
        system
        code
      }
      denominator {
        value
        comparator
        unit
        system
        code
      }
    }
    valueSampledData {
      origin {
        value
        comparator
        unit
        system
        code
      }
      period
      factor
      lowerLimit
      upperLimit
      dimensions
      data
    }
    valueTime
    valueDateTime
    valuePeriod {
      start
      end
    }
    dataAbsentReason {
      text
      coding {
        system
        code
        display
      }
    }
    interpretation {
      text
      coding {
        system
        code
        display
      }
    }
    note {
      authorReference {
        reference
        type
        display
      }
      authorString
      time
      text
    }
    bodySite {
      text
      coding {
        system
        code
        display
      }
    }
    method {
      text
      coding {
        system
        code
        display
      }
    }
    specimen {
      reference
      type
      display
    }
    device {
      reference
      type
      display
    }
    referenceRange {
      low {
        value
        comparator
        unit
        system
        code
      }
      high {
        value
        comparator
        unit
        system
        code
      }
      type {
        text
        coding {
          system
          code
          display
        }
      }
      appliesTo {
        text
        coding {
          system
          code
          display
        }
      }
      age {
        low {
          value
          comparator
          unit
          system
          code
        }
        high {
          value
          comparator
          unit
          system
          code
        }
      }
      text
    }
    hasMember {
      reference
      type
      display
    }
    derivedFrom {
      reference
      type
      display
    }
    component {
      code {
        text
        coding {
          system
          code
          display
        }
      }
      valueQuantity {
        value
        comparator
        unit
        system
        code
      }
      valueCodeableConcept {
        text
        coding {
          system
          code
          display
        }
      }
      valueString
      valueBoolean
      valueInteger
      valueRange {
        low {
          value
          comparator
          unit
          system
          code
        }
        high {
          value
          comparator
          unit
          system
          code
        }
      }
      valueRatio {
        numerator {
          value
          comparator
          unit
          system
          code
        }
        denominator {
          value
          comparator
          unit
          system
          code
        }
      }
      valueSampledData {
        origin {
          value
          comparator
          unit
          system
          code
        }
        period
        factor
        lowerLimit
        upperLimit
        dimensions
        data
      }
      valueTime
      valueDateTime
      valuePeriod {
        start
        end
      }
      dataAbsentReason {
        text
        coding {
          system
          code
          display
        }
      }
      interpretation {
        text
        coding {
          system
          code
          display
        }
      }
    }
  }
`);
